import BaseErrorHandler from '@/apis/errorHandler/handler/BaseErrorHandler'
import  AlertTypeEnum from '@/apis/errorHandler/AlertTypeEnum'

export default class EntityNotFoundException extends BaseErrorHandler {
    protected Code: string = "Common.EntityNotFoundException";
    protected AlertType:AlertTypeEnum=AlertTypeEnum.WARNING;

    customizeAction(): void {
    }
}
